import * as Sentry from '@sentry/nextjs'
import { Identify, identify } from '@amplitude/analytics-browser'

import { ResolvedTheme, ThemePreference } from '@/lib/theme'

/**
 * Stamp the theme on error reports and analytics, so a bug report can be read against
 * what the user actually saw. The theme lives only in this device's localStorage, so
 * there is no server copy to look up afterwards.
 *
 * Both values are sent: `ui_theme` is what rendered, `ui_theme_preference` is what was
 * picked — `system` alone does not say which one the user was looking at.
 *
 * Amplitude copies user properties onto every later event, so each event carries the
 * theme that was active when it fired. Calls made before init() are queued by the SDK.
 */
export function reportTheme(preference: ThemePreference, resolved: ResolvedTheme): void {
  Sentry.setTag('ui_theme', resolved)
  Sentry.setTag('ui_theme_preference', preference)
  identify(new Identify().set('ui_theme', resolved).set('ui_theme_preference', preference))
}
